var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-text-link",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("prefixIcon"),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("suffixIcon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }